module.exports = __webpack_public_path__ + "media/images/black_history_month/okra-dish-86e959ba696058e0d001948029d16d67.png";